


























import ExercisesCardioTabNav from './ExercisesCardioTabNav.vue'
import ExercisesCardioItem from './ExercisesCardioItem.vue'
import { withDefault, withUnit } from '@/components/exercises/measure/filters'
import * as R from 'ramda'
import { DEFAULT_CARDIO_EXERCISE } from '@/store/modules/exercise/constants'

export default {
  components: {
    ExercisesCardioItem,
    ExercisesCardioTabNav,
  },
  filters: {
    withDefault,
    withUnit,
  },
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    exercise: {
      type: Object,
      required: true,
      validator: obj => ['id', 'cardioExercises'].every(key => key in obj),
    },
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
  computed: {
    cardioExercises() {
      return this.exercise.cardioExercises || []
    },
    currentCardioExercises() {
      return this.cardioExercises[this.activeIndex] || null
    },
  },
  methods: {
    addCardioExercise() {
      const copiedCardioExercises = R.clone(this.cardioExercises)
      copiedCardioExercises.push(R.clone(DEFAULT_CARDIO_EXERCISE))
      this.$emit('update:exercise-param', 'cardioExercises', copiedCardioExercises)
      this.$nextTick(() => {
        this.activeIndex = Math.max(this.cardioExercises.length - 1, 0)
      })
    },
    deleteCardioExercise(index) {
      const copiedCardioExercises = R.clone(this.cardioExercises)
      copiedCardioExercises.splice(index, 1)
      this.activeIndex = Math.max(0, Math.min(copiedCardioExercises.length - 1, this.activeIndex))
      this.$emit(
        'update:exercise-param',
        'cardioExercises',
        copiedCardioExercises.length ? copiedCardioExercises : null
      )
    },
    updateCardioExercise(index: number, name: string, value: any) {
      const copiedCardioExercises = R.clone(this.cardioExercises)
      const targetCardioExercise = this.cardioExercises[index]
      copiedCardioExercises.splice(index, 1, {
        ...targetCardioExercise,
        [name]: value,
      })
      this.$emit('update:exercise-param', 'cardioExercises', copiedCardioExercises)
    },
  },
}
